import { Box } from '@mui/material';
import React from 'react';

interface IStringSVGComponentProps {
  svgString: string;
  color: string;
  dataTest: string;
}

export const StringSVGComponent: React.FC<IStringSVGComponentProps> = ({ svgString, color, dataTest }) => {
  const svgRef = React.useRef<HTMLDivElement>(null);

  const validSvgPrefix = '<svg';
  const validSvgSuffix = '</svg>';

  // Simple checks for <svg> tags at the beginning and end of the string
  const svgStringHasValidPrefix = svgString.trim().startsWith(validSvgPrefix);
  const svgStringHasValidSuffix = svgString.trim().endsWith(validSvgSuffix);

  const isValidSvgString = svgStringHasValidPrefix && svgStringHasValidSuffix;

  React.useEffect(() => {
    if (svgRef.current && isValidSvgString) {
      // tslint:disable-next-line:no-inner-html
      svgRef.current.innerHTML = svgString;
    }
  }, [svgString, isValidSvgString]);

  if (!isValidSvgString) {
    console.error('Invalid SVG string provided to StringSVGComponent: ', svgString);
    return null;
  }

  return (
    <Box display="flex" alignItems="center" ref={svgRef} sx={{ svg: { fill: color } }} data-test={dataTest}>
      {svgString}
    </Box>
  );
};
